/* =====================================================================
   ISHVARI WEBSITE V3 — PRODUCT RECOMMENDATIONS SYSTEM (PDP v5.0.0)
   ---------------------------------------------------------------------
   Fetches Shopify's native product recommendations for the current
   product and swaps them into the section that's already on the page.
   This is the documented, minimal JS exception described in
   sections/product-recommendations.liquid: there is no zero-JavaScript
   way to use Shopify's native algorithmic `recommendations` object,
   because it's only populated on a request carrying a `section_id`
   parameter, not on the page's initial render.

   Vanilla JS, no dependencies, IIFE-wrapped — consistent with every
   other script in this theme (assets/header.js, assets/product-hero.js,
   assets/footer.js).
   ===================================================================== */
(function () {
  'use strict';

  function initProductRecommendations(container) {
    var url = container.getAttribute('data-url');
    var sectionId = container.getAttribute('data-section-id');
    if (!url || !sectionId) return;

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Recommendations request failed');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var refreshed = doc.getElementById('ProductRecommendations-' + sectionId);
        if (refreshed && refreshed.innerHTML.trim().length > 0) {
          container.innerHTML = refreshed.innerHTML;
        }
      })
      .catch(function () {
        /* Silently leave the section empty — no recommendations is a
           valid, non-broken state, not an error the shopper needs to see. */
      });
  }

  function init() {
    var containers = document.querySelectorAll('.product-recommendations[data-url]');
    containers.forEach(initProductRecommendations);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
